import { render, staticRenderFns } from "./adSpaceConfig.vue?vue&type=template&id=abbf3bdc&scoped=true&"
import script from "./adSpaceConfig.vue?vue&type=script&lang=js&"
export * from "./adSpaceConfig.vue?vue&type=script&lang=js&"
import style0 from "./adSpaceConfig.vue?vue&type=style&index=0&id=abbf3bdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbf3bdc",
  null
  
)

export default component.exports